import React from 'react';
import './detailDeepBoxJob.css'

const DetailDeepBoxJob = ({ title, data }) => {
  return (
    <div className='detail-deep-job__container'>
      <h3>{title}</h3>
      <div className="detail-deep-job__description-container">
        <p>{data}</p>
      </div>
    </div>
  );
};

export default DetailDeepBoxJob;